import { Builder } from "@builder.io/react";
import { S19TimelineSection } from "../components/interactive-sections/S19Timeline";
import { BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES } from "../BuilderComponentsName";
import { backgroundGradientOptions, iconColorOptions, textColorOptionsLimited } from "../utils/builderColorOptions";
import { getBackgroundColorInput, getBackgroundGradientInput, getPaddingInputs } from "../utils/builderSharedInputs";


Builder.registerComponent(S19TimelineSection, {
    name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S19Timeline,
    inputs: [
        {
            name: "headline",
            type: "string",
            defaultValue: "Headline",
            // helperText: "Headline for the icons",
            required: true,
        },
        {
            name: "headlineColor",
            type: "string",
            defaultValue: "Blue",
            friendlyName: "Headline Color",
            enum: textColorOptionsLimited,
            // helperText: "Color of the headline text",
            required: false,
        },


        {
            name: "timelineData",
            type: "list",
            onChange: (options) => {
                // check if the list has less than 8 items
                if (options.get('timelineData').length < 8) {
                    alert('minimum items are 8, add items to continue')
                }
            },

            subFields: [
                {
                    name: "date",
                    type: 'date',
                    friendlyName: "Timeline Date",
                    required: true,
                    defaultValue: new Date(),
                },
                {
                    name: "icon",
                    type: 'file',
                    friendlyName: "Timeline Icon",
                    required: true,
                    defaultValue: "",
                },
                {
                    name: "image",
                    type: 'file',
                    friendlyName: "Timeline Image",
                    defaultValue: "",
                    required: true,
                },
                {
                    name: "imageAlt",
                    type: 'string',
                    friendlyName: "Timeline ImageAlt",
                    defaultValue: "",
                    required: true,
                },
                {
                    name: "title",
                    type: 'string',
                    friendlyName: "Timeline Title",
                    defaultValue: "",
                    required: true,
                },

            ],

            defaultValue: [
                { id: 1, date: '2012-11-08T22:20:40.504Z', icon: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F6c3fa4e433a3484198d62640bf058a72', image: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F5880a367ad7945079e744bd3a3759dc5', title: "Clinic #1 founded in Papillion, NE", imageAlt: "Clinic #1 founded in Papillion, NE" },
                { id: 2, date: '2018-11-08T22:20:40.504Z', icon: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F32b2e439d22545b788df4ecb5b84f7dc', image: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F5fe35a669f504576b79c8559df76d54e', title: "Clinic #40 opens Reached 210 employees", imageAlt: "Clinic #40 opens Reached 210 employees" },
                { id: 3, date: '2019-11-08T22:20:40.504Z', icon: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2Fe5f8277621044ceaa83b5a42043533b5', image: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F05cbb3ceb8bb44ae84e778e1437b96c2', title: "Clinic #50 opens", ImageAlt: "Clinic #50 opens" },
                { id: 4, date: '2020-11-08T22:20:40.504Z', icon: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F380d3a1da4144ab1a149dfb3b817b60b', image: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F42b9c66bb8fe4e6c8ac57bd5e99e32b4', title: "Clinic #100 opens", imageAlt: "Clinic #100 opens" },
                { id: 5, date: '2022-11-08T22:20:40.504Z', icon: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F45f0630aa04e4d919c6c3952b522f471', image: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2Fa44269dac42c4413b482dd46e1dfa0c0', title: "Celebrated 10th anniversary 1,500+ employees", imageAlt: "Celebrated 10th anniversary 1,500+ employees" },
                { id: 6, date: '2023-11-08T22:20:40.504Z', icon: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F3b110b5d439648e896aafee98672b46d', image: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F1f888f5945cb4020bb9720bda0acafbf', title: "Clinic #300 opens 60K clients treated per month", imageAlt: "Clinic #300 opens 60K clients treated per month" },
                { id: 7, date: '2024-11-08T22:20:40.504Z', icon: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F233d5a3a821a488680082db033d68ece', image: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F8ee2fc7ff9114509bec803b5ef99513a', title: "Opened in New York City", imageAlt: "Opened in New York City" },
                { id: 8, date: '2025-11-08T22:20:40.504Z', icon: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F40adc607caba493d8752cbfe1a5ff469', image: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F63f0afd01d4a4217ac6bb157a82b04f3', title: "Operating in 37 states 100K+ 5-star reviews", imageAlt: "Operating in 37 states 100K+ 5-star reviews" },

            ],
            helperText: "List of timeline items to display",
            required: true,
        },
        {
            name: "timelineEntryIconColor",
            type: "string",
            defaultValue: "Navy",
            friendlyName: "Timeline Icon Color",
            helperText: "Color change will apply to SVG icons only",
            enum: iconColorOptions,
            required: false,
        },
        {
            name: "timelinetitleColor",
            type: "string",
            defaultValue: "Turquoise",
            friendlyName: "Timeline Title Color",
            enum: textColorOptionsLimited,
            required: false,
        },
        {
            name: "timelineDateColor",
            type: "string",
            defaultValue: "Turquoise",
            friendlyName: "Timeline Date Text Color",
            enum: textColorOptionsLimited,
            required: false,
        },
        {
            name: "timelineSelectedDateColor",
            type: "string",
            defaultValue: "Turquoise",
            friendlyName: "Timeline Selected Date Text Color",
            enum: textColorOptionsLimited,
            required: false,
        },
        ...getBackgroundColorInput({}),
        ...getBackgroundGradientInput({
            defaultValue: 'BlueTop',
            backgroundGradientList: backgroundGradientOptions
        }),
        {
            name: 'backgroundImage',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
            friendlyName: 'Background Image',
            helperText: 'Upload an image to use as the section background'
        },
        ...getPaddingInputs({
            desktopTop: 'small',
            desktopBottom: 'none',
            mobileTop: 'small',
            mobileBottom: 'none',
        })
    ],
    friendlyName: "S19 Timeline",
});

